<template>
  <v-container class="d-flex flex-column ga-3">
    <UsageExample v-model="tab" :code="code" :tabs="tabs">
      <v-row>
        <v-col col="4">
          <v-card elevation="4">
            <v-card-title class="font-weight-bold">Starting</v-card-title>
            <div class="pa-8">
              <hx-linear-progress :value="0" :total :unit :state="'ok'" />
            </div>
          </v-card>
        </v-col>

        <v-col col="4">
          <v-card elevation="4">
            <v-card-title class="font-weight-bold">Ongoing</v-card-title>
            <div class="pa-8">
              <hx-linear-progress :value="10" :total :unit :state="'ok'" />
            </div>
          </v-card>
        </v-col>

        <v-col col="4">
          <v-card elevation="4">
            <v-card-title class="font-weight-bold">Complete</v-card-title>
            <div class="pa-8">
              <hx-linear-progress :value="15" :total :unit :state="'ok'" />
            </div>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col col="4">
          <v-card elevation="4">
            <v-card-title class="font-weight-bold">Warning</v-card-title>
            <div class="pa-8">
              <hx-linear-progress :value="10" :total :unit :state="'warning'" />
            </div>
          </v-card>
        </v-col>

        <v-col col="4">
          <v-card elevation="4">
            <v-card-title class="font-weight-bold">Error</v-card-title>
            <div class="pa-8">
              <hx-linear-progress :value="10" :total :unit :state="'error'" />
            </div>
          </v-card>
        </v-col>

        <v-col col="4"></v-col>
      </v-row>
    </UsageExample>
  </v-container>
</template>

<script>
import UsageExample from '@/components/helix/utils/UsageExample';

export default {
  name: 'HelixLinearProgress',
  components: { UsageExample },
  setup() {
    const code = `
      <template>
        <v-container class="d-flex flex-column ga-3">
          <v-row>
            <v-col col="4">
              <v-card elevation="4">
                <v-card-title class="font-weight-bold">Starting</v-card-title>
                <div class="pa-8">
                  <hx-linear-progress :value="0" :total="15" :unit="Tasks" :state="'ok'" />
                </div>
              </v-card>
            </v-col>

            <v-col col="4">
              <v-card elevation="4">
                <v-card-title class="font-weight-bold">Ongoing</v-card-title>
                <div class="pa-8">
                  <hx-linear-progress :value="10" :total="15" :unit="Tasks" :state="'ok'" />
                </div>
              </v-card>
            </v-col>

            <v-col col="4">
              <v-card elevation="4">
                <v-card-title class="font-weight-bold">Complete</v-card-title>
                <div class="pa-8">
                  <hx-linear-progress :value="15" :total="15" :unit="Tasks" :state="'ok'" />
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-row>
            <v-col col="4">
              <v-card elevation="4">
                <v-card-title class="font-weight-bold">Warning</v-card-title>
                <div class="pa-8">
                  <hx-linear-progress :value="10" :total="15" :unit="Tasks" :state="'warning'" />
                </div>
              </v-card>
            </v-col>

            <v-col col="4">
              <v-card elevation="4">
                <v-card-title class="font-weight-bold">Error</v-card-title>
                <div class="pa-8">
                  <hx-linear-progress :value="10" :total="15" :unit="Tasks" :state="'error'" />
                </div>
              </v-card>
            </v-col>

            <v-col col="4"></v-col>
          </v-row>
        </v-container>
      </template>
      `;
    return {
      code
    };
  },

  data() {
    return {
      label: 'Linear Progress Label',
      tab: 'Linear Progress Usage',
      tabs: ['Linear Progress Usage'],
      total: 15,
      unit: 'Tasks'
    };
  }
};
</script>
